import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { CLEARING_DOC_API } from "./apiRoutes";

interface UseGetUnclearLineItemsProps {
  communityId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUnclearLineItems = async (communityId: string, data: any) =>
  await axiosAuth.post(
    `${CLEARING_DOC_API(communityId)}/cc-unclear-line-items/grid`,
    data
  );

const useGetUnclearLineItems = ({
  communityId,
  data,
  queryParams,
}: UseGetUnclearLineItemsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["unclear-line-items", communityId],
    queryFn: () => getUnclearLineItems(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetUnclearLineItems;
